<template>
    <!-- IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): картинка виджета (utils/widgetPreviews.js) — в прямоугольнике схемы страницы (вид «Page previews»
         панели страниц) и на карточке меню страницы (вид «Widget previews»); нет картинки — значок строки (и подпись, если просили). object-fit: cover от левого
         верхнего угла — угол отчёта самый узнаваемый. Картинка устарела (запись виджета сохранена позже с другим doc / записи нет / размер строки на странице
         изменился) — значок pi-history в правом верхнем углу; сама картинка остаётся видна. Объяснение — только по Alt / Show tooltips (menuPanel.widgetPreview) -->
    <span class="wp-img" :class="{ 'is-empty': !url, 'is-stale': !!staleWhy, 'is-fill': fill }" :data-wp-key="pic ? pic.key : null" v-uiHelp="help_b">
        <img v-if="url" :src="url" class="wp-img-pic" alt="" draggable="false" />
        <i v-else-if="icon" :class="icon" class="wp-img-ico"></i>
        <span v-if="!url && title && showTitle" class="wp-img-t">{{ title }}</span>
        <i v-if="url && staleWhy" class="pi pi-history wp-img-stale"></i>
    </span>
</template>

<script>
import { t } from '@/i18n'
import { useMainStore } from '@/stores/mainStore'
import { widgetPreviews_staleWhy, widgetPreviews_capturedText, wpState } from '@/utils/widgetPreviews'

export default {
    name: 'WidgetPreviewImg',
    props: {
        pic: { type: Object, default: null },      // картинка (widgetPreviews_pic / _picOfRow): { key, url, at, by, mode, kind, lay, tab, chips_text, stale_record, … }
        icon: { type: String, default: '' },       // значок, когда картинки нет
        title: { type: String, default: '' },      // заголовок виджета (подсказка; подпись при showTitle без картинки)
        lay: { type: Object, default: null },      // раскладка строки страницы сейчас (utils/widgetPreviews.wpLayOf) — для «размер изменился»
        showTitle: { type: Boolean, default: false },
        fill: { type: Boolean, default: true },    // заполнить родителя (position: absolute; inset: 0)
    },
    setup() { let store = null; try { store = useMainStore() } catch (e) { store = null } return { store } },
    computed: {
        url() { void wpState.epoch; return (this.pic && this.pic.url) || '' },
        staleWhy() { void wpState.epoch; return this.pic ? widgetPreviews_staleWhy(this.store, this.pic, this.lay) : '' },
        help_b() {
            if (!this.pic) return null
            const p = this.pic
            const size = (p.src_w && p.src_h) ? `${p.src_w} × ${p.src_h} px` : ''
            return { key: 'menuPanel.widgetPreview', state: () => (this.staleWhy ? 'stale' : 'fresh'),
                vars: () => ({ title: this.title || p.widget, captured: widgetPreviews_capturedText(p), chips: p.chips_text || '—', tab: p.tab || '—', size: size || '—', stale: this.staleWhy }) }
        },
    },
    methods: { t },
}
</script>

<style>
/* IE 2026 09 27 / ODOO-… (заказ Игоря: картинки виджетов): картинка заполняет прямоугольник (обрезка по cover от левого верхнего угла), значок — по центру.
   Не scoped: живёт в телепортированной панели */
.wp-img { display: flex; align-items: center; justify-content: center; overflow: hidden; box-sizing: border-box; min-width: 0; min-height: 0; background: var(--surface-card, #fff); }
.wp-img.is-fill { position: absolute; inset: 0; }
.wp-img:not(.is-fill) { position: relative; width: 100%; height: 100%; }
.wp-img-pic { display: block; width: 100%; height: 100%; object-fit: cover; object-position: left top; user-select: none; pointer-events: none; }
.wp-img-ico { font-size: 22px; line-height: 1; color: var(--text-color-secondary, #6c757d); opacity: .75; }
.wp-img-t { position: absolute; left: 4px; right: 4px; bottom: 3px; font-size: 10px; line-height: 12px; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;
    color: var(--text-color-secondary, #6c757d); }
.wp-img-stale { position: absolute; top: 2px; right: 2px; font-size: 10px; line-height: 1; padding: 2px; border-radius: 3px; color: #8a6d00; background: rgba(255, 244, 204, .92);
    box-shadow: 0 0 0 1px rgba(138, 109, 0, .35); }
.page-schema-w .wp-img-ico { font-size: 10px; }
</style>
